import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ScreenService {
  private mobileMaxWidth = 639;
  private isMobileSubject = new BehaviorSubject<boolean>(false);

  isMobile$ = this.isMobileSubject.asObservable();

  constructor(
    @Inject(DOCUMENT) private readonly document: Document,
    @Inject(PLATFORM_ID) private readonly platformId: Object
  ) {
    if (!isPlatformBrowser(this.platformId)) return;
    const windowRef = this.document.defaultView;
    if (!windowRef) return;

    this.isMobileSubject.next(this.checkIfMobile(windowRef));
    windowRef.addEventListener(
      'resize',
      () => this.isMobileSubject.next(this.checkIfMobile(windowRef)),
      { passive: true }
    );
  }

  private checkIfMobile(windowRef: Window): boolean {
    return windowRef.innerWidth <= this.mobileMaxWidth;
  }
}
